export default "__VITE_ASSET__Btrdl4nf__"